import React from "react";
import { Link } from "react-router-dom";

function AdminHome() {
  return (
    <div>
      <Link to="/liste-marques-admin">Gestion des marques</Link>
      <br />
      <Link to="/liste-fournisseurs-montures">Gestion des fournisseurs</Link>
      <br />
      <Link to="/liste-fournisseurs-verres">Gestion des verriers</Link>
      <br />
      <Link to="/liste-fournisseurs-lentilles">
        Gestion des fournisseurs lentilles
      </Link>
      <br />
      <Link to="/liste-mutuelles-admin">Gestion des mutuelles</Link>
    </div>
  );
}

export default AdminHome;
